import React, { useCallback } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import ActivityIcon from '@mui/icons-material/Assignment';

import { formatDateTime } from '@ts-core/core/utils/dateFormatters';

import BaseTimelineCard from '@ts-core/components/Timeline/BaseTimelineCard';
import Typography from '@ts-core/components/Typography';
import Button from '@ts-core/components/Button';

import { StudentActivity } from '@ts-core/modules/activities/types';

interface TimeLineActivityCardProps {
  activity: StudentActivity;
  academy: any;
}

const TimeLineActivityCard = (props: TimeLineActivityCardProps) => {
  const { activity, academy } = props;
  const intl = useIntl();
  const history = useHistory();
  const { courseId } = useParams<{ courseId: string }>();

  const handleDoActivity = useCallback(() => {
    history.push(`/${courseId}/activities/${activity.id}/do`);
  }, [history, courseId, activity]);

  return (
    <BaseTimelineCard title={activity.createdBy.name} subtitle={academy.name}>
      <Stack direction="row" spacing={1} alignItems="center">
        <ActivityIcon />
        <Typography fontSize={20} fontWeight={500}>
          {activity.name}
        </Typography>
      </Stack>
      <Box mt={1}>
        <Typography variant="body2" color="textSecondary" display="inline">
          {intl.formatMessage({ id: 'activity.deadline' })}:
        </Typography>
        <Typography variant="body2" display="inline" ml={1} fontWeight={700}>
          {formatDateTime(activity.deadline)}
        </Typography>
      </Box>
      <Box width="100%" display="flex" justifyContent="flex-end">
        <Button color="secondary" onClick={handleDoActivity}>
          Hacer Tarea
        </Button>
      </Box>
    </BaseTimelineCard>
  );
};

export default TimeLineActivityCard;
